<div class="flex justify-between w-full" aria-label="expand underwriting memos">
  <span
    class="uw-memo-landing-header cui-h2 mt-auto mb-auto"
    id="underwritingMemoLanding"
  >
    Underwriting Memos
  </span>
  <span class="cui-h5 flex-grow-1" data-pgr-id="breakdownSummary">
    {{ breakdownSummary }}
  </span>
  <div class="flex-shrink-0 mr-s my-bl-1">
    <button
      mat-icon-button
      aria-label="refresh"
      data-pgr-id="btnRefresh"
      (click)="refreshMemos($event)"
      (keydown.enter)="refreshMemos($event)"
      class="mr-bl-2"
    >
      <mat-icon>refresh</mat-icon>
    </button>
  </div>
</div>
